export default __webpack_public_path__ + "static/media/twitter.59ada547.svg";